PageVue
  template(v-slot:body)
    KycStepperVue(v-if='fan' :fan='fan' @completed='goToProfile' :key='fan')
